import React, { useState } from 'react'
import axios from 'axios'
import { useParams } from 'react-router-dom'
import '../TmsStyles/SelfRegistration.css'

const SelfRegistration = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    contactNumber: '',
  })

  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null)
  const [success, setSuccess] = useState(false)
  const { training_id } = useParams()

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsLoading(true)
    setError(null)
    setSuccess(false)

    const apiUrl = `https://tdtlworld.com/dss-kaas-backend/tms/training/${training_id}/enrollments/`
    const token = localStorage.getItem('jwttoken')

    try {
      const response = await axios.post(
        apiUrl,
        {
          name: formData.name,
          email: formData.email,
          mobile_number: formData.contactNumber,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      setSuccess(true)
      console.log('API Response:', response.data)
    } catch (err) {
      console.error('Error submitting form:', err)
      setError('Failed to register. Please try again later.')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className='tfeedback-form-container'>
      <div className='tfeedback-form'>
        <h2 className='tfeedback-form-title'>Get Registered</h2>
        {error && <p className='error-message'>{error}</p>}
        {success && <p className='success-message'>Registration successful!</p>}
        <form onSubmit={handleSubmit} className='space-y-4'>
          <div className='tform-group'>
            <label htmlFor='name' className='tform-label'>
              Name
            </label>
            <input
              id='name'
              name='name'
              type='text'
              value={formData.name}
              onChange={handleChange}
              placeholder='Enter your name'
              required
              className='tform-input'
            />
          </div>
          <div className='tform-group'>
            <label htmlFor='email' className='tform-label'>
              Email
            </label>
            <input
              id='email'
              name='email'
              type='email'
              value={formData.email}
              onChange={handleChange}
              placeholder='Enter your email'
              required
              className='tform-input'
            />
          </div>
          <div className='tform-group'>
            <label htmlFor='contactNumber' className='tform-label'>
              Contact Number
            </label>
            <input
              id='contactNumber'
              name='contactNumber'
              type='tel'
              value={formData.contactNumber}
              onChange={handleChange}
              placeholder='Enter your contact number'
              className='tform-input'
            />
          </div>
          <button type='submit' className='tsubmit-button' disabled={isLoading}>
            {isLoading ? 'Registering...' : 'Register'}
          </button>
        </form>
      </div>
    </div>
  )
}

export default SelfRegistration
